import { DownloadCsvActionTypes } from "./constants";

const GET_INITIAL_DOWNLOAD_CSV = {
    downloadCsv: [],
    loading: false,
    error: null
};

const transactionCsvReducer = (state = GET_INITIAL_DOWNLOAD_CSV, action) => {
    switch (action.type) {
        case DownloadCsvActionTypes.GET_TRANSACTION_CSV_LOADING:
            return {
                ...state,
                loading: true,
            };
        case DownloadCsvActionTypes.GET_TRANSACTION_CSV_SUCCESS:
            return {
                downloadCsv: action.payload,
                loading: false,
            };
        case DownloadCsvActionTypes.GET_TRANSACTION_CSV_ERROR:
            return {
                downloadCsv: action.payload,
                loading: false,
            };
        case DownloadCsvActionTypes.GET_DOWNLOAD_CSV_RESET:
            return { ...GET_INITIAL_DOWNLOAD_CSV };
        default:
            return state;
    }
};

const accountCsvReducer = (state = GET_INITIAL_DOWNLOAD_CSV, action) => {
    switch (action.type) {
        case DownloadCsvActionTypes.GET_ACCOUNT_CSV_LOADING:
            return {
                ...state,
                loading: true,
            };
        case DownloadCsvActionTypes.GET_ACCOUNT_CSV_SUCCESS:
            return {
                downloadCsv: action.payload,
                loading: false,
            };
        case DownloadCsvActionTypes.GET_ACCOUNT_CSV_ERROR:
            return {
                downloadCsv: action.payload,
                loading: false,
            };
        case DownloadCsvActionTypes.GET_DOWNLOAD_CSV_RESET:
            return { ...GET_INITIAL_DOWNLOAD_CSV };
        default:
            return state;
    }
};
const traderCsvReducer = (state = GET_INITIAL_DOWNLOAD_CSV, action) => {
    switch (action.type) {
        case DownloadCsvActionTypes.GET_TRADER_CSV_LOADING:
            return {
                ...state,
                loading: true,
            };
        case DownloadCsvActionTypes.GET_TRADER_CSV_SUCCESS:
            return {
                downloadCsv: action.payload,
                loading: false,
            };
        case DownloadCsvActionTypes.GET_TRADER_CSV_ERROR:
            return {
                downloadCsv: action.payload,
                loading: false,
            };
        case DownloadCsvActionTypes.GET_DOWNLOAD_CSV_RESET:
            return { ...GET_INITIAL_DOWNLOAD_CSV };
        default:
            return state;
    }
};
const userCsvReducer = (state = GET_INITIAL_DOWNLOAD_CSV, action) => {
    switch (action.type) {
        case DownloadCsvActionTypes.GET_USER_CSV_LOADING:
            return {
                ...state,
                loading: true,
            };
        case DownloadCsvActionTypes.GET_USER_CSV_SUCCESS:
            return {
                downloadCsv: action.payload,
                loading: false,
            };
        case DownloadCsvActionTypes.GET_USER_CSV_ERROR:
            return {
                downloadCsv: action.payload,
                loading: false,
            };
        case DownloadCsvActionTypes.GET_DOWNLOAD_CSV_RESET:
            return { ...GET_INITIAL_DOWNLOAD_CSV };
        default:
            return state;
    }
};
const commodityCsvReducer = (state = GET_INITIAL_DOWNLOAD_CSV, action) => {
    switch (action.type) {
        case DownloadCsvActionTypes.GET_COMMODITY_CSV_LOADING:
            return {
                ...state,
                loading: true,
            };
        case DownloadCsvActionTypes.GET_COMMODITY_CSV_SUCCESS:
            return {
                downloadCsv: action.payload,
                loading: false,
            };
        case DownloadCsvActionTypes.GET_COMMODITY_CSV_ERROR:
            return {
                downloadCsv: action.payload,
                loading: false,
            };
        case DownloadCsvActionTypes.GET_DOWNLOAD_CSV_RESET:
            return { ...GET_INITIAL_DOWNLOAD_CSV };
        default:
            return state;
    }
};


export { transactionCsvReducer, accountCsvReducer, traderCsvReducer, userCsvReducer, commodityCsvReducer }